<template>
  <div v-b-tooltip.hover class="action-rounded" :class="[{ 'white-background': backgroundWhite }, size]" :title="name">
    <i :class="setIconClass"> </i>
  </div>
</template>

<script>
export default {
  name: 'action-rounded',

  props: {
    icon: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'primary',
    },
    backgroundWhite: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
    },
    name: {
      type: String,
      default: '',
    },
    positive: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    setIconClass() {
      let classes = `text-${this.positive ? 'white' : this.color} ${this.icon} border-${this.color}`
      if (this.positive) {
        classes += ` bg-${this.positive ? this.color : 'white'}`
      }
      return classes
    },
  },
}
</script>

<style scoped>
.round-btn {
  height: 23px !important;
  padding-top: 1px !important;
  padding-bottom: 0px !important;
}
</style>
